import { v_QuoteInvoiceBus } from "./v_QuoteInvoiceBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { v_QuoteDetailBus } from "./v_QuoteDetailBus";
import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class v_QuoteBus extends BaseBus
{
    constructor(dataObj: v_QuoteBus = null) {
        super(dataObj);
        if (dataObj != null) {
            this.insertDt = DateFunctions.getDate(this.insertDt);
        }
    }
  quoteId: any;
  companyId: any;
  customerId: any;
  locationId: any;
  quoteStatusId: any;
  quoteNumber: string;
  poNumber: string;
  quoteDate: Date;
  quoteDesc: string;
  quoteStatusName: string;
  locationName: string;
  amount: number;
  total: number;
  taxCodeId: any;
    taxAmount: number;
  useTax: number;
  woNumber: string;
  co: number;
  isOpen: boolean;
  needsApproval: boolean;
  isActiveLocation: boolean;
    isTemplate: boolean;
    insertDt: Date;
  locationDetail: v_LocationDetailBus;
  quoteInvoices: v_QuoteInvoiceBus[];
  quoteDetail: v_QuoteDetailBus;
}
